module.exports = __webpack_public_path__ + "img/icon-integrations-for-your-event.748d0e57.png";